import React from 'react';
import { MainContent, PageHeading } from '../../components/Shell/Content';
import Documents from './Documents';

const DocumentsEntry = () => {
	return (
		<MainContent maxWidth="max-w-7xl">
			<PageHeading divider={false}>Documents</PageHeading>

			<Documents />
		</MainContent>
	);
};

export default DocumentsEntry;
